/**
 * The Chats scope before anything is typed: the caller's recent
 * conversations, in the same row shape as a chat search result (title and
 * time; no matched line, so no snippet). A list that could not load says so
 * rather than reading as "you have no chats".
 */

import { Box, Text } from '@chakra-ui/react';
import { Command } from 'cmdk';
import { ChatResultItem } from './ChatResultItem';
import type { AgentSessionSummary, ChatSearchResult } from '../../../services/agentChat.service';

interface RecentChatsGroupProps {
  readonly sessions: readonly AgentSessionSummary[];
  readonly failed: boolean;
  readonly isLoading: boolean;
  readonly onSelect: (result: ChatSearchResult) => void;
}

function Note({ children }: { readonly children: string }) {
  return (
    <Box px={3} py={3}>
      <Text fontSize="sm" color="text.muted">
        {children}
      </Text>
    </Box>
  );
}

export function RecentChatsGroup({ sessions, failed, isLoading, onSelect }: RecentChatsGroupProps) {
  if (failed) {
    return (
      <Command.Group heading="Recent chats">
        <Note>Your recent chats could not be loaded. Type to search them.</Note>
      </Command.Group>
    );
  }
  if (sessions.length === 0) {
    return isLoading ? null : (
      <Command.Group heading="Recent chats">
        <Note>No chats yet. Ask Bower a question to start one.</Note>
      </Command.Group>
    );
  }
  return (
    <Command.Group heading="Recent chats">
      {sessions.map((session) => (
        <ChatResultItem
          key={session.session_id}
          result={{
            session_id: session.session_id,
            message_id: '',
            title: session.title,
            role: '',
            snippet: '',
            timestamp: session.last_update_time,
          }}
          onSelect={onSelect}
        />
      ))}
    </Command.Group>
  );
}
